import { useCallback } from "react";

import { SessionCard } from "./SessionCard";

import type { SharedSession } from "@/queries/prompts";

export interface SharePromptSessionRowProps {
  session: SharedSession;
  index: number;
  onUpdate: (
    sessionId: string,
    fields: Partial<
      Pick<
        SharedSession,
        | "name"
        | "is_public"
        | "batch_enabled"
        | "chat_enabled"
        | "remix_enabled"
        | "label_name"
        | "version_number"
      >
    >,
  ) => void;
  onDelete: (sessionId: string) => void;
  hideModeSelector?: boolean;
}

export const SharePromptSessionRow = ({
  session,
  index,
  onUpdate,
  onDelete,
  hideModeSelector = false,
}: SharePromptSessionRowProps) => {
  const handleUpdate = useCallback(
    (
      fields: Partial<
        Pick<
          SharedSession,
          | "name"
          | "is_public"
          | "batch_enabled"
          | "chat_enabled"
          | "remix_enabled"
          | "label_name"
          | "version_number"
        >
      >,
    ) => {
      onUpdate(session.id, fields);
    },
    [onUpdate, session.id],
  );

  const handleDelete = useCallback(() => {
    onDelete(session.id);
  }, [onDelete, session.id]);

  return (
    <SessionCard
      index={index}
      session={session}
      onUpdate={handleUpdate}
      onDelete={handleDelete}
      hideModeSelector={hideModeSelector}
    />
  );
};
